import React, { useRef, useEffect } from 'react'
import { useFrame } from '@react-three/fiber'
import * as THREE from 'three'

const GlitchEffect = () => {
  const meshRef = useRef()
  
  // Create glitch shader material
  const glitchMaterial = new THREE.ShaderMaterial({
    uniforms: {
      time: { value: 0 },
      glitchIntensity: { value: 0.1 },
    },
    vertexShader: `
      varying vec2 vUv;
      void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }
    `,
    fragmentShader: `
      uniform float time;
      uniform float glitchIntensity;
      varying vec2 vUv;
      
      float random(vec2 st) {
        return fract(sin(dot(st.xy, vec2(12.9898,78.233))) * 43758.5453123);
      }
      
      void main() {
        vec2 uv = vUv;
        
        // Digital noise
        float noise = random(uv + time * 0.1);
        
        // Glitch lines
        float glitch = step(0.98, random(vec2(floor(uv.y * 100.0), time * 10.0)));
        
        // Color channels
        vec3 color = vec3(0.0);
        color.r = noise * glitch;
        color.g = 0.0;
        color.b = noise * glitch * 0.5;
        
        gl_FragColor = vec4(color, glitch * glitchIntensity);
      }
    `,
    transparent: true,
    blending: THREE.AdditiveBlending,
  })

  useFrame((state) => {
    if (meshRef.current) {
      glitchMaterial.uniforms.time.value = state.clock.elapsedTime
      
      // Random glitch intensity spikes
      if (Math.random() < 0.01) {
        glitchMaterial.uniforms.glitchIntensity.value = Math.random() * 0.5
      } else {
        glitchMaterial.uniforms.glitchIntensity.value *= 0.95
      }
    }
  })

  return (
    <mesh ref={meshRef} position={[0, 0, 5]}>
      <planeGeometry args={[20, 20]} />
      <primitive object={glitchMaterial} />
    </mesh>
  )
}

export default GlitchEffect
